import React, { useMemo } from 'react';
import {
  getTimezoneDate,
  translate,
  isTeamDefined,
} from 'containers/MundialViews/utils/mundialUtils';
//--------------------------------------------------------------------------
import { FadeInImage } from 'components/FadeInImage';
import './style.scss';
import { useSelector } from 'react-redux';
import { showPlaceHolderorImg } from 'containers/MundialViews/utils/mundialUtils';
import placeholderVcard from 'containers/MundialViews/assets/placeholder/placeholderBigCard.png';
import { getRegion } from '../../../../../../utils/Region';
import { pushEvent } from 'containers/Player/utils/analytics';
import {
  events,
  Actions,
  category,
} from 'containers/MundialViews/utils/analytics';
import { useOpenPlayer } from '../../../../../../hooks/useOpenPlayer';

export const CalendarRow = ({ match, translations }) => {
  const { openPlayerWithTransaction } = useOpenPlayer();
  const qatarConfig =
    useSelector(state => state.metadata?.match_live_button) || null;
  const { vcard_team_placeholder_img: flagPlaceholder } = useSelector(
    state => state.asset,
  );

  const enablePlay = useMemo(
    () => {
      if (qatarConfig) {
        const enable =
          JSON.parse(qatarConfig)[getRegion()]?.enable ||
          JSON.parse(qatarConfig).default?.enable;
        return enable;
      }
      return false;
    },
    [qatarConfig],
  );

  const onPlayClick = () => {
    pushEvent(
      events.CARDMATCH,
      category.MENU,
      Actions.CALENDAR,
      `ver ahora - ${match?.homeParticipant?.names?.full} vs ${
        match?.awayParticipant?.names?.full
      }`,
    );
    pushEvent(
      events.CARDMATCH,
      category.MENU,
      Actions.CALENDAR,
      `${match?.dateAndTimeInfo?.startDateLocal}`,
    );

    if (qatarConfig) {
      const groupId =
        JSON.parse(qatarConfig)[getRegion()]?.group_id ||
        JSON.parse(qatarConfig).default?.group_id;
      openPlayerWithTransaction(groupId);
    }
    pushEvent(
      events.PLAYER,
      category.PLAYER,
      Actions.WORDCUP,
      `${match?.homeParticipant?.names.full} vs ${
        match?.awayParticipant?.names.full
      }`,
    );
  };

  return (
    <div className="calendar-row">
      <div className="calendar-row__schedule">
        <span className="calendar-row__schedule__label">
          {translate('calendar_result_hour_label', translations)}
        </span>
        <span>
          {getTimezoneDate(match.dateAndTimeInfo.scheduledStartTimeUTC).hour}{' '}
          {translate('match_detail_hourAbbreviation_label', translations)}
        </span>
      </div>
      <div className="calendar-row__match">
        <span className="calendar-row__match__label">
          {translate('calendar_result_teams__label', translations)}
        </span>
        <span className="calendar-row__match__FN">
          {match.homeParticipant.names.default} vs.{' '}
          {match.awayParticipant.names.default}
        </span>
      </div>
      <div className="calendar-row__flags">
        {isTeamDefined(match.homeParticipant) ? (
          <>
            <FadeInImage
              classNames={['calendar-row__flags__flag']}
              imageSrc={showPlaceHolderorImg(
                match.homeParticipant.nationality.images.flag,
                placeholderVcard,
              )}
              imageAlt={'Mundial flag'}
              width={48}
              height={32}
            />
          </>
        ) : (
          <>
            <FadeInImage
              classNames={['flag-placeholder__img']}
              imageSrc={flagPlaceholder}
              imageAlt="mundial flag"
              width={27}
              height={32}
            />
          </>
        )}
        {isTeamDefined(match.awayParticipant) ? (
          <FadeInImage
            classNames={['calendar-row__flags__flag']}
            imageSrc={showPlaceHolderorImg(
              match.awayParticipant.nationality.images.flag,
              placeholderVcard,
            )}
            imageAlt={'Mundial flag'}
            width={48}
            height={32}
          />
        ) : (
          <FadeInImage
            classNames={['flag-placeholder__img']}
            imageSrc={flagPlaceholder}
            imageAlt="mundial flag"
            width={27}
            height={32}
          />
        )}
      </div>
      <div className="calendar-row__action">
        {match.status.scheduleStatus === 'IN_PROGRESS' && enablePlay && (
          <button
            className="calendar-row__action__button"
            onClick={onPlayClick}
          >
            {translate('calendar_result_option_button_play', translations)}
          </button>
        )}
      </div>
    </div>
  );
};
